import { t as tr } from '../i18n.js'
import { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router'
import { api, ApiError } from '../api.js'
import { useAuth } from '../auth.js'

/** Landing page for the email-change verification link (works signed in or out). */
export function ConfirmEmailPage() {
  const { token = '' } = useParams()
  const { refresh } = useAuth()
  const [state, setState] = useState<{ ok: true; email: string } | { ok: false; error: string } | null>(null)
  useEffect(() => {
    let alive = true
    api<{ email: string }>('/email/confirm', { method: 'POST', json: { token } })
      .then(async (r) => { await refresh(); if (alive) setState({ ok: true, email: r.email }) })
      .catch((e) => { if (alive) setState({ ok: false, error: e instanceof ApiError ? e.message : 'Request failed' }) })
    return () => { alive = false }
  }, [token]) // refresh is stable
  return (
    <div className="shell">
      <h1>{tr("Confirm email")}</h1>
      {!state && <p className="muted">{tr("Checking…")}</p>}
      {state?.ok && <p className="good">{tr("Done — your sign-in email is now")} <strong>{state.email}</strong>. <Link to="/account">{tr("Account")}</Link></p>}
      {state && !state.ok && <p className="bad">{state.error} <Link to="/account">{tr("Account")}</Link></p>}
    </div>
  )
}
